// Emory's undergraduate majors (#2596, founder 2026-09-30: "majors offered by
// the college in the public page"). Read on 2026-09-30 from Emory's official
// 2026-2027 catalogs (Coursedog): the Emory College of Arts and Sciences
// catalog's Programs list (every active Major with a BA or BS, plus the one
// Co-Major), and the bachelor's programs in the Goizueta Business School
// (BBA) and Nell Hodgson Woodruff School of Nursing (BSN) catalogs. The
// catalog list shows short codes; the names here are each program's full
// name as its page shows it (the transcript description, without the word
// "Major"). The Nursing catalog carries several BSN plan codes, all named
// Nursing: one row. Oxford College's catalog lists no programs of its own;
// its students choose from these Emory majors (Oxford's Majors and Minors
// page), so Oxford's Class of 2030 rate rides with Emory College's in that
// group (both from the college file's `classProfile` source, same numbers as
// its byMajor table). Minors, the Undeclared plan and graduate programs are
// left out. Typography is plain ASCII. The KB's majors list was the starting
// point; the catalogs win.
const majors = {
    "slug": "emory-university",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in Emory's official 2026-2027 catalogs, grouped by the school that offers it, with the degree it leads to. Oxford College students choose from these same majors. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Emory College of Arts and Sciences",
            "source": {
                "label": "Emory College of Arts and Sciences Catalog 2026-2027, Programs",
                "url": "https://college.catalog.emory.edu/programs"
            },
            "rate": {
                "text": "Class of 2030, who started in fall 2026: Emory College admitted 3,852 of 42,873 applicants (9%). Oxford College, Emory's other first-year college, admitted 2,773 of 27,113 (10%).",
                "source": "classProfile"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "African Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Ancient Mediterranean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology & Human Biology",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics & Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Arabic",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Classical Civilization",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Classics & English",
                    "degree": "BA"
                },
                {
                    "name": "Classics & History",
                    "degree": "BA"
                },
                {
                    "name": "Classics & Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Dance and Movement Studies",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "East Asian Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics & Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Economics & Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Economics and Human Health",
                    "degree": "BA"
                },
                {
                    "name": "Engineering Science",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English & Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "English & History",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Film and Media",
                    "degree": "BA"
                },
                {
                    "name": "French Studies",
                    "degree": "BA"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "Global Portuguese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Greek",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History and Art History",
                    "degree": "BA"
                },
                {
                    "name": "Human Health",
                    "degree": "BA"
                },
                {
                    "name": "Integrated Visual Arts",
                    "degree": null,
                    "note": "Co-major"
                },
                {
                    "name": "Interdisciplinary Studies in Society & Culture",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Middle Eastern and South Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience & Behavioral Biology",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy & Religion",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics, Law",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics and Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Physics and Astronomy",
                    "degree": "BS"
                },
                {
                    "name": "Playwriting",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Psychology and Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis",
                    "degree": "BS"
                },
                {
                    "name": "Religion",
                    "degree": "BA"
                },
                {
                    "name": "Religion & Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Religion & Classical Civilization",
                    "degree": "BA"
                },
                {
                    "name": "Religion & History",
                    "degree": "BA"
                },
                {
                    "name": "Religion & Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Russian, East European, and Eurasian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Spanish & Portuguese",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Theater Studies",
                    "degree": "BA"
                },
                {
                    "name": "Women's, Gender and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Goizueta Business School",
            "source": {
                "label": "Goizueta Business School Catalog 2026-2027, Programs",
                "url": "https://goizueta.catalog.emory.edu/programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "Nell Hodgson Woodruff School of Nursing",
            "source": {
                "label": "Nell Hodgson Woodruff School of Nursing Catalog 2026-2027, Programs",
                "url": "https://nursing.catalog.emory.edu/programs"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        }
    ]
};

export default majors;
